import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import { useEffect, useState } from "react";
import Button from "src/components/Form/Button";
import Subheading from "src/components/Subheading";
import TextInput from "src/components/Form/TextInput";
import useFormFields from "src/hooks/useFormFields";
import usePersistantState from "src/hooks/usePersistantState";
import FormCheckbox from "src/components/Form/FormCheckbox";
import MultiInput from "src/components/MultiInput/MultiInput";



export default function JobAnalysisPage4({ handleStep, handleStepDown }) {

    const [tasks, setTasks] = useState([]);
    const [change, setChange] = useState(true);
    const addTask = () => {
        if (taskInputs.length < 14) {
            const newTasks = tasks;
            newTasks.push((tasks.length) + 1);
            setTasks(newTasks);
            setChange(!change);
        }
    }
    const { fields, handleChange } = useFormFields({})

    const [shayestegihayeOmoomi, setShayestegihayeOmoomi] = usePersistantState("shayestegihayeOmoomi", {
        "خود کنترلی": {
            value: {},
            desc: "(كنترل رفتارها، تمایلات، هیجان ها و اندیشه خود و حفظ خونسردی، آرامش و سطح عملكرد موثر خود در مواجهه با شرایط سخت و استرس زا)"
        },
        "اعتماد به نفس": {
            value: {},
            desc: "(باور و اعتقاد به قابلیت ها و توانایی های خود با در نظر گرفتن نقاط قوت و ضعف خویش و بدون حس غرور و تعصب. همچنین احترام به خود و ارزش قائل بودن برای خود)"
        },
        "پیشگامی و ابتكارعمل": {
            value: {},
            desc: "(كارها به صورت فعالانه، به جای آن كه منتظر پیشنهاد یا دستور دیگران بودن. انجام دادن كارها فراتر از آن چه مورد انتظار یا مورد نیاز است و همچنین انجام دادن)"
        },
        "یادگیری مداوم": {
            value: {},
            desc: "(نشان دادن تعهد به یادگیری مداوم و رشد خود و تلاش مستمر برای كسب دانش، مهارت و تخصص لازم و مورد نیاز حرفه خود)"
        },
        "سازگاری و انعطاف پذیری": {
            value: {},
            desc: "(وفق دادن سریع خود با موقعیت های متغیر و محیط ها و فرهنگ های گوناگون و با افراد مختلف به صورت كارآمد و در نظر گرفتن رویكردهای جدید برای شرایط جدید)"
        },
        "توجه به جزئیات": {
            value: {},
            desc: "(دقت در انجام یك كار با در نظر گرفتن تمامی حوزه ها و بخش های كوچك و بزرگ درگیر در كار و توجه به جزئیات و ظرایف آن)"
        },
        "پاسخگویی": {
            value: {},
            desc: "(پذیرفتن مسئولیت در قبال همه ی فعالیت هایی كه بر عهده ی فرد گذاشته می شود و پاسخگو بودن در قبال نتایج و پیامدهای آن و همچنین حس وظیفه شناسی و پیگیری دلسوزانه امور محوله)"
        },
        "هوشیاری فناورانه": {
            value: {},
            desc: "(آگاهی از آخرین فناوری روز (سخت افزار، نرم افزار و فناوری های ارتباطی) و فناوری های نوظهور و كاربردهای آن ها و استفاده و بكارگیری از آن ها جهت به روز كردن فرآیندهای كاری متناسب با مقتضیات زمان)"
        },
        "هوشیاری مالی و تجاری": {
            value: {},
            desc: "(شناخت و درك مناسب از اصول اساسی مالی، حسابداری، و اقتصادی به منظور قضاوت صحیح هنگام تصمیم گیری و به كارگیری از آن جهت بهبود كارایی و سودآوری بیشتر سازمان)"
        },
        "نتیجه گرایی": {
            value: {},
            desc: "(تمركز بر دستیابی به نتایج مطلوب فردی و سازمانی و تلاش مستمر برای حركت در مسیر اهداف تعیین شده و دستیابی به نتایج مطلوب و اهداف موردنظر)"
        },
        "حل مسئله": {
            value: {},
            desc: "(توانایی شناسایی مشكلات و مسائل موجود و استفاده از یك رویكرد منطقی و نظام مند برای رسیدن به یك راه حل كارآمد و موثر جهت مقابله با مشكلات و مسائل شناسایی شده)"
        },
        "تصمیم گیری": {
            value: {},
            desc: "(توانایی تجزیه و تحلیل مشكلات و مسائل و استفاده از طیف وسیعی از ابزارها برای تصمیم گیری به موقع و آگاهانه به طوری كه واقعیت ها، اهداف، محدودیت ها و ریسك ها در هنگام تصمیم گیری در نظر گرفته شوند)"
        },
        "ارتباطات شفاهی": {
            value: {},
            desc: "(انتقال صحیح اطلاعات و بیان افكار و حقایق به دیگران به روش شفاهی و استفاده موثر از مهارت شنیداری و توجه به نقطه نظرات و ایده های دیگران)"
        },
        "كار تیمی": {
            value: {},
            desc: "(توانایی همكاری اثربخش با دیگران برای دستیابی به اهداف مشترك سازمانی، بدون تكیه بر روابط رسمی سازمانی و موقعیت های افراد در چارت های رسمی)"
        },
        "تیم و شبكه سازی": {
            value: {},
            desc: "(ایجاد و گسترش روابط گروهی و مشترك و استفاده از روش های مناسب و انعطاف پذیر برای ساختن تیم های رسمی و غیر رسمی كه رسیدن به اهداف تیمی را تسهیل می بخشند)"
        },
        "همدلی": {
            value: {},
            desc: "(توانایی درك اندیشه ها، احساسات و نگرانی های دیگران و فهم تجربه حسی دیگران با قرار دادن خود در جایگاه آن ها و دیدن دنیا از دریچه چشم آن ها)"
        },
        "مدیریت تعارض": {
            value: {},
            desc: "(مواجهه و برخورد مناسب با دیگران در وضعیت خصومت آمیز و استفاده از شیوه ها و روش های مناسب بین فردی برای كاهش تنش یا تعارض بین دو یا چند نفر)"
        },
        "مشتری مداری": {
            value: {},
            desc: "(داشتن درك عمیق و صحیح از نیازها و انتظارات مشتریان و انجام اقدامات مورد نیاز جهت ارائه خدمات با كیفیت جهت جلب رضایت مشتریان)"
        },
        "جامعیت و تنوع گرایی": {
            value: {},
            desc: "(ایجاد یك محیط كار متنوع و فراگیر كه تمامی افراد با نژادها، قومیت ها، جنسیت ها و فرهنگ های متفاوت احساس احترام و ارزشمندی كنند و فرصت پیشرفت داشته باشند)"
        },
        "تفكر خلاق": {
            value: {},
            desc: "(استفاده از اطلاعات، دانش و ایده های خود برای ایجاد راه حل های بكر و بدیع و زیر سوال بردن رویكردهای متداول و كشف جایگزین ها و پاسخ به چالش ها همراه با به كار گیری راهكارهای خلاقانه، شهودی و دیدگاه های جدید)"
        },
        "تفكر استراتژیك": {
            value: {},
            desc: "(توانایی پیش بینی محیط آینده با توجه به فرصت ها و تهدیدها و اتخاذ مجموعه اقدامات مناسب جهت دستیابی به اهداف كلان و چشم انداز سازمان بعد از بررسی اطلاعات، منابع، محدودیت ها و فرصت ها و تهدیدهای موجود)"
        },
        "تفكر تحلیلی": {
            value: {},
            desc: "(استفاده از یك رویكرد و فرآیند منطقی و نظام مند برای تجزیه و تحلیل مسائل و تشخیص صحیح مفروضات مربوط به هر واقعه یا سناریو ، ارزیابی صحیح استدلالات ارائه شده، توانایی قیاس و تفسیر موضوعات)"
        },
        "تفكر نقادانه": {
            value: {},
            desc: "(توانایی تفكر و اندیشه مستدل و منطقی پیرامون مسائل و قضاوت و تصمیم گیری بر مبنای استدلال و شواهد منطقی)"
        },
        "شم سیاسی": {
            value: {},
            desc: "(آگاهی و شناخت سیاست های داخلی و خارجی كه بر فعالیت سازمان تاثیر می گذارد. درك واقعیت های سیاسی و عمل كردن بر اساس آن ها به گونه ای كه بیشترین اثربخشی و كمترین آثار جانبی منفی برای سازمان ایجاد شود)"
        },
        "نظارت و كنترل": {
            value: {},
            desc: "(بررسی پیشرفت برنامه ها و اهداف تعیین شده و میزان دستیابی به آن ها و استخراج مغایرت ها و انحرافات در جهت بهبود وضع موجود)"
        },
        "برنامه ریزی و سازماندهی": {
            value: {},
            desc: "(برنامه ریزی، اولویت بندی و تعیین اهداف و برنامه های عملیاتی از منابع و زمان و به انجام رساندن وظایف كاری تعیین شده)"
        },
        "قدرت مذاكره و متقاعدسازی": {
            value: {},
            desc: "(توانایی اثرگذاری بر افكار، احساسات و نگرش دیگران و انجام مذاكره موفق و كسب توافق و دستیابی به این تضمین كه توافق حاصل از مذاكره اهداف مورد نظر سازمان را تامین می كند)"
        },
        "ایجاد انگیزه و الهام بخشی به دیگران": {
            value: {},
            desc: "(توانایی افزایش تعهد كاری در دیگران با ایجاد انگیزه و روحیه در آن ها تا بتوانند به سازمان در پیشبرد اهدافش كمك كنند)"
        },
        "رهبری": {
            value: {},
            desc: "(توانایی اعمال نفوذ و ایجاد انگیزه و روحیه در افراد و تشویق آن ها به انجام وظایف و تعهدات شغلی شان تا بتوانند به سازمان در پیشبرد اهدافش كمك كنند)"
        },
        "توسعه دیگران": {
            value: {},
            desc: "(برنامه ریزی و حمایت از توسعه مهارت ها و توانایی های افراد به طوری كه بتوانند مسئولیت های شغلی فعلی و آینده خود را موثرتر انجام بدهند)"
        },
        "پایش و مدیریت عملكرد": {
            value: {},
            desc: "(كنترل و نظارت بر عملكرد افراد و واحدهای سازمانی با در نظر گرفتن راهبردهای سازمانی و از طریق تعیین شاخص ها و معیارهای عملكردی و اندازه گیری آن ها برای اطمینان از دستیابی به اهداف سازمانی)"
        }
    })

    const taskInputs = tasks.map((task, index) => (<TextInput inputName={`شایستگی تخصصی ${index + 2}`} label=" " key={index} placeholder={`شایستگی تخصصی ${index + 2}`} handleChange={handleChange} />))
    return (
        <PanelLayout>
            <Title title="تجزیه و تحلیل شغل" />
            <Progressbar activePart={4} handleStep={handleStep} />
            <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">


                <Subheading title="شایستگی‌های عمومی" subTitle="حداکثر 8 مورد را به عنوان خیلی ضروری می‌توانید انتخاب کنید" isFirst={true} />
                <FormCheckbox maxFive={8} state={shayestegihayeOmoomi} setState={setShayestegihayeOmoomi} newButtonLabel="افزودن مورد جدید" />

                <Subheading title="شایستگی‌های تخصصی" />
                {/* <div className="mt-10">
                    <TextInput label="شایستگی‌های تخصصی:" placeholder="شایستگی 1 - صرفا شایستگی‌های تخصصی یا اختصاصی هر شغل در این قسمت باید وارد شود." inputName="شایستگی تخصصی 1" handleChange={handleChange} />
                    <div className="">
                        {taskInputs}
                    </div>
                    <div className="flex items-center mb-5">
                        <div className="w-28 inline-block text-right mr-4 text-gray-500"></div>
                        <button onClick={addTask}
                            className="flex w-[250px] justify-center items-center rounded-lg border-2 border-gray-400 placeholder-gray-300 outline-none focus:border-main-color hover:bg-[#5B5CFF] hover:text-white transition duration-300">
                            <span className="text-yellow-500 font-extrabold text-[1.3rem] m-2">+</span>
                            اضافه کردن شایستگی تخصصی
                        </button>
                    </div>
                </div> */}
                <div className="my-6"></div>
                <MultiInput name="shayestegihayeTakhasosi" width={150} singleInputCount={5} inputPlaceholders={["عنوان شایستگی","شرح شایستگی","مولفه‌های شایستگی","برنامه توسعه","آزمون/ابزار"]}/>

                <div className="flex justify-center items-center relative mt-10 z-50">
                    <Button isPrevious={true} title="مرحله قبل" direction="center" handleClick={(event) => handleStepDown()} color="#f9b302" />
                    <Button title="ثبت اطلاعات و تکمیل فرم بعدی" direction="center" handleClick={(event) => handleStep()} />
                </div>
            </div>



        </PanelLayout>
    )
}